/*
 * @Description: 权限管理页面设置路由
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const authorityManagement: Array<RouteRecordRaw> = [
	{
		path: '/authorityManagement',
		component: Layout,
		redirect: '/authorityManagement/authorityManagementList',
		children: [
			{
				path: 'authorityManagementList',
				component: () => import(/* webpackChunkName: "authorityManagementList" */ '@/views/authorityManagement/authorityManagementList/index.vue'),
				name: 'authorityManagementList',
				meta: { title: '权限管理' }
			}
		]
	}
]

export default authorityManagement
